/**
 * Formats "today" using the visitor's own region, inferred from the browser's
 * IANA time zone (which reflects the location their IP resolves to) and the
 * browser language. Falls back to a generic Spanish (LATAM) format.
 */

const TIMEZONE_LOCALE: Record<string, string> = {
  'America/Mexico_City': 'es-MX',
  'America/Monterrey': 'es-MX',
  'America/Tijuana': 'es-MX',
  'America/Bogota': 'es-CO',
  'America/Lima': 'es-PE',
  'America/Santiago': 'es-CL',
  'America/Argentina/Buenos_Aires': 'es-AR',
  'America/Montevideo': 'es-UY',
  'America/Asuncion': 'es-PY',
  'America/La_Paz': 'es-BO',
  'America/Caracas': 'es-VE',
  'America/Guayaquil': 'es-EC',
  'America/Guatemala': 'es-GT',
  'America/Costa_Rica': 'es-CR',
  'America/Panama': 'es-PA',
  'America/Santo_Domingo': 'es-DO',
  'America/Havana': 'es-CU',
  'America/San_Juan': 'es-PR',
  'Europe/Madrid': 'es-ES',
}

export function getVisitorLocale(): string {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (timeZone && TIMEZONE_LOCALE[timeZone]) return TIMEZONE_LOCALE[timeZone]
    const language = typeof navigator !== 'undefined' ? navigator.language : ''
    if (language && language.toLowerCase().startsWith('es')) return language
  } catch {
    /* noop — fall through to the default */
  }
  return 'es-419'
}

/** e.g. "martes, 15 de septiembre de 2026" */
export function getTodayLongDate(): string {
  const locale = getVisitorLocale()
  try {
    return new Intl.DateTimeFormat(locale, {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(new Date())
  } catch {
    return new Date().toLocaleDateString('es-419', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })
  }
}

/** e.g. "15 de septiembre" */
export function getTodayShortDate(): string {
  const locale = getVisitorLocale()
  try {
    return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' }).format(new Date())
  } catch {
    return new Date().toLocaleDateString('es-419', { day: 'numeric', month: 'long' })
  }
}

export function capitalizeFirst(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1)
}
